module.exports = __webpack_public_path__ + "static/media/IMG-20220311-WA0000.47e1eb13.jpg";